import { Helmet } from "react-helmet-async";

/**
 * Per-page SEO meta tag injector for the DR AI FUTBOL marketing site.
 * Renders <title>, meta description, canonical, Open Graph, Twitter Card.
 *
 * Usage:
 *   <MarketingSEO
 *     title="Fiyatlandırma — DR AI Futbol"
 *     description="Kulübünüze uygun paketi seçin..."
 *     path="/fiyatlandirma"
 *   />
 */
const SITE_NAME = "DR AI FUTBOL";
const BASE_URL = "https://draifutbol.com";
const DEFAULT_IMAGE = `${BASE_URL}/marketing-v2/hero-stadium.png`;

export default function MarketingSEO({
    title,
    description,
    path = "/",
    image = DEFAULT_IMAGE,
    type = "website",
    noindex = false,
}) {
    const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — Futbol kulüpleri için yapay zeka destekli dijital yönetim`;
    const url = `${BASE_URL}${path || "/"}`;
    const ogImage = image && image.startsWith("http") ? image : `${BASE_URL}${image}`;
    const desc = description || "Türk futbol kulüpleri için yapay zeka destekli dijital yönetim platformu. Panel + kurumsal web sitesi, tek paket.";

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={desc} />
            <link rel="canonical" href={url} />
            {noindex && <meta name="robots" content="noindex,nofollow" />}

            {/* Open Graph */}
            <meta property="og:type" content={type} />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={desc} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={ogImage} />
            <meta property="og:locale" content="tr_TR" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={desc} />
            <meta name="twitter:image" content={ogImage} />
        </Helmet>
    );
}
